import clsx from 'clsx'
import './Services.css'
import useMediaQuery from 'hook/useMediaQuery'
import { MediaTablet } from 'api/const/MediaQuery'
import { Loader, Logo } from 'components/atoms'
import { Link } from 'react-router-dom'
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { ServicesTable } from 'components/organism'
import { getMatchFeaturedServices, postServicesList } from 'api/Api'
import { PaginatedRequest } from 'components/types/Api'
import { initialPager, initialServiceReq } from 'components/types/InitialData'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext'
import useIntersection from 'hook/useIntersection'
import { useScrollBlock } from 'hook/useScrollBlock'

export type Service = {
  id: string,
  title: string,
  shortDescription: string,
  isAdv: boolean,
  logoUrl?: string,
  longDescription?: string,
  isMatched: boolean
}



export const Services = () => {
  const tablet = useMediaQuery(MediaTablet)
  const [selectedId, setSelectedId] = useState<string>('')
  const [request, setRequest] = useState<PaginatedRequest>(initialServiceReq)
  const [loadingList, setLoadingList] = useState<boolean>(false)
  const refBottomTable = useRef<HTMLDivElement | null>(null)
  const inViewport = useIntersection(refBottomTable, '20px')
  const { setErrorModal, } = useContext(AppGeneralContext)
  const [totalPage, setTotalPage] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [blockScroll, allowScroll] = useScrollBlock()
  const updateRequest = (update: Partial<PaginatedRequest>) => {
    let updated = { ...request, ...update }
    setRequest(updated)
  }
  const [servicesList, setServicesList] = useState<Service[]>([])

 

  //blocco scrool se sta in caricamento
  useEffect(() => {
    if (isLoading || loadingList) {
      blockScroll()
    } else {
      allowScroll()
    }
  }, [isLoading, loadingList])

  //resetta la servicesList
  const resetList = () => {
    window.scrollTo(0, 0);
    setRequest(initialServiceReq);
  }

  //chiama la lista quando renderizza e la resetta quando esce dalla pagina
  useEffect(() => {
    getList(request,false)
    return () => {
      resetList()
    }
  }, [])


  // chiama la lista quando si aggiorna la request
  useEffect(() => {
    getList(request,false)
  }, [request.pageNum])

  //chiamata  lista 

  const getList = useCallback((req: PaginatedRequest, isMatched: boolean) => {
    if (isMatched) {setIsLoading(true)  }else{setLoadingList(true)}
    
    postServicesList(req).then((res) => {

      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        setIsLoading(false)
        setLoadingList(false)
        return
      }

      const response = res.response.data
   
      if (req.pageNum === 0) {
        setServicesList(response)
      } else {
        setServicesList(x => [...x, ...response])
      }
      setTotalPage(res.response.pager.totalPages - 1 )
      setIsLoading(false)
      setLoadingList(false)
    })
 
  }, [request.pageNum])


  //aggiorna la request quando la ref è visibile
  useEffect(() => {
    
    if (inViewport.isVisible === false) {
      return
    }

    if(request.pageNum >= totalPage){
      return
    }


    setRequest(x => ({ ...x, pageNum: x.pageNum + 1 }))

  }, [inViewport.isVisible])


  // chiama il match e resetta la lista
  async function AskMatch(serviceId: string) {
    await getMatchFeaturedServices(serviceId).then((res) => {

      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return 
      }
      window.scrollTo(0, 0);
      setRequest(initialServiceReq)
      getList(initialServiceReq, true)
    })
  }





  const table = useMemo(() => {

    if (servicesList.length > 0) {
      return (
        <div className="relative w-100 d-flex align-items-center justify-content-center ">
          <ServicesTable  setIsLoading={setIsLoading} isLoading={isLoading} data={servicesList} askMatch={AskMatch} selectedId={selectedId} setSelectedId={setSelectedId} />
        </div>
      )
    }

    return (
      <div className='w-100 text-center mt-4 '>
        <h6>No result</h6>
      </div>
    )
  }, [servicesList, isLoading, selectedId])

  return (

    <div className={clsx("row m-0 p-0 ",)}>
      <div className=" mt-3 m-0 p-0">
        <div className='d-flex flex-column justify-content-center m-0 p-0 pb-2 border-bottom'>
          <h3 className='m-0 fw-700'>Featured services</h3>
          <p className="p-0 m-0 my-3 services-desc">Discover the best services dedicated to the growth of your Innovative project.</p>
        </div>
      </div>
      <div className="m-0 p-0 mb-2  table-services " >
        {isLoading &&
        <div className="position-fixed " style={{zIndex:999, top:0, left:0 , width:tablet? "100vw" : "76vw", height:"100vh"}}>
         <div className="w-100 h-100  d-flex align-items-center justify-content-center"> 
          <Loader />
          </div>
          </div>
        }
         {table}
        {loadingList && <Loader />}
      </div>
      <div ref={refBottomTable} className=' mb-5' style={{ height: "8px" }} />
      {tablet &&
        <div className="m-0 p-0 mb-5 footer-margin " />
      }
    </div >


  )
}
